<ng-progress class="root-progress-bar" color="#dd7309" [thick]="true" [spinner]="false"></ng-progress>
@if (loading) {
  <nz-layout class="h-screen">
    <div class="size-full flex items-center justify-center">Loading...</div>
  </nz-layout>
} @else {
  <router-outlet></router-outlet>
}
